import SurgerMenu_bg_1 from './shutterstock_352907537.jpg';
import SurgerMenu_bg_2 from './27111893_s.jpg';
import SurgerMenu_bg_3 from './34839249_s.jpg';
import SurgerMenu_bg_4 from './shutterstock_196238198.jpg';
import SurgerMenu_bg_5 from './12796661_s.jpg';
import SurgerMenu_bg_6 from './9524750_s.jpg';

export default [
  undefined, SurgerMenu_bg_1, SurgerMenu_bg_2, SurgerMenu_bg_3, SurgerMenu_bg_4, SurgerMenu_bg_5, SurgerMenu_bg_6
]



// WEBPACK FOOTER //
// ./src/assets/img/llc/surgery/index.js